import { useEffect, useState } from 'react'
import { platformService } from '@/services/platformService'

const clp = (n: number) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(n || 0)

function Bars({ title, data, fmt }: { title: string; data: Record<string, number>; fmt?: (n: number) => string }) {
    const entries = Object.entries(data || {})
    const max = Math.max(1, ...entries.map(([, v]) => v))
    return (
        <div className="rounded-xl border border-slate-800 bg-slate-800/40 p-5">
            <h2 className="mb-4 text-sm font-medium text-slate-300">{title}</h2>
            <div className="space-y-2">
                {entries.map(([k, v]) => (
                    <div key={k} className="flex items-center gap-3">
                        <div className="w-28 shrink-0 text-xs text-slate-400">{k}</div>
                        <div className="h-3 flex-1 overflow-hidden rounded-full bg-slate-900">
                            <div className="h-full rounded-full bg-indigo-500" style={{ width: `${(v / max) * 100}%` }} />
                        </div>
                        <div className="w-24 shrink-0 text-right text-xs text-slate-300">{fmt ? fmt(v) : v}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default function BiPage() {
    const [bi, setBi] = useState<any>(null)

    useEffect(() => { platformService.crmBi().then(setBi).catch(() => { /* noop */ }) }, [])

    if (!bi) return <div className="text-slate-400">Cargando BI…</div>

    const cards = [
        { label: 'Pipeline abierto', value: clp(bi.openPipelineValue), cls: 'text-indigo-400' },
        { label: 'Ganado', value: clp(bi.wonValue), cls: 'text-emerald-400' },
        { label: 'Conversión leads', value: `${bi.conversionRate}%`, cls: 'text-sky-400' },
        { label: 'Leads totales', value: bi.totalLeads, cls: 'text-slate-200' },
        { label: 'Tenants', value: bi.tenants, cls: 'text-slate-200' },
    ]

    return (
        <div className="space-y-8">
            <h1 className="text-2xl font-semibold">BI Ejecutivo</h1>

            <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
                {cards.map((c) => (
                    <div key={c.label} className="rounded-xl border border-slate-800 bg-slate-800/50 p-5">
                        <div className={`text-2xl font-semibold ${c.cls}`}>{c.value}</div>
                        <div className="mt-1 text-xs text-slate-400">{c.label}</div>
                    </div>
                ))}
            </div>

            <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                <Bars title="Leads por estado" data={bi.leadsByStatus} />
                <Bars title="Oportunidades por etapa (n°)" data={bi.oppsByStage} />
                <Bars title="Valor del pipeline por etapa" data={bi.valueByStage} fmt={clp} />
            </div>
        </div>
    )
}
